import { useSelector } from "react-redux"
import { ReactSVG } from "react-svg"

const ConnectNotiftInTelegram = () => {

    const profile = useSelector(state => state.profile.profile)
    
    if (profile?.first_name){
        return (
            <div className="lg:px-1 px-5">  
                { !profile.telegram_connected ?
                    <a href={profile?.telegram_url} target="_blank" className="btn lg:px-4 px-0 outline outline-4 outline-[#49b450]/20 bg-[#49b450] rounded-xl mx-auto mb-4 gap-2 text-sm"> 
    
                        <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/telegram.svg`} className="w-5 h-5" />
    
                        <span className="font-medium"> اتصال به تلگرام </span>
    
                    </a>
                    :
                    <a href={'https://t.me/vakilsunbot?start=uid_'+profile?.telegram_token} target="_blank" className="btn lg:px-4 px-0 outline outline-4 outline-red-500/20 bg-red-500 rounded-xl mx-auto mb-4 gap-2 text-sm"> 
    
                        <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/telegram.svg`} className="w-5 h-5" />
    
                        <span className="font-medium"> قطع اتصال تلگرام </span>
    
                    </a>
                }
    
            </div>    
        )
    }
    
     return (
            <>  
              
            </>    
        )

}

export default ConnectNotiftInTelegram